function onClick(techBlock, infoBlock) {
  techBlock.toggleClass('on');
  this.toggleClass('on');
  infoBlock.slideToggle();
}


$(window).ready(function () {

  if (window.location.href.indexOf("ring-mea-dev.myshopify.com/ar/") > -1) {
    var body = document.body;
    body.setAttribute("dir", "RTL")
  }

  $('.category-block').each(function (index) {
    $this = $(this);
    $techBlock = $this.closest('.tech-block');
    $infoBlock = $techBlock.find('.info-block').first();

    // Binding clicks
    $this.click(onClick.bind($this, $techBlock, $infoBlock));

    // First Block Expanded is not needed now
    // if (index == 0) {
    //  $this.click();
    // }
  });

  $('.security-cam.has-dropdown').click(function(e) {

      cur_dropdown = $(this).closest('.security-cam').find('.dropdown');
      cur_dropdown_icon = $(this).find('.dropdown-icon');
      cur_dropdown_flag = "false";
      $('.security-cams').find($('.dropdown')).not(cur_dropdown).each(function(){
          $(this).hide();
      });
      $('.security-cams').find($('.dropdown-icon')).not(cur_dropdown_icon).each(function() {
          $(this).removeClass("inverted");
      });

      $(this).find('.dropdown-icon').toggleClass('inverted');
      cur_dropdown.slideToggle();

      $('.security-cams').find($('.dropdown-icon')).each(function(){
          if($(this).hasClass("inverted")) {
              cur_dropdown_flag = $(this).hasClass("inverted");
          }
      });

      if ($('.security-cams').css("overflow") == "auto" || $('.security-cams').css("overflow").includes("hidden")) {
          $('.security-cams').css("overflow", "visible").addClass('dropdown-opened');
      }
      else if ($('.security-cams').css("overflow").includes("visible") && cur_dropdown_flag == "false"){
          setTimeout(() => {
              $('.security-cams').css("overflow", "hidden").removeClass('dropdown-opened');
          }, 200)
      }
  });

  if ($('.locate_this').length > 0) {
    var element = $('.locate_this');
  
    var media = $(element).find('video').get(0);
    var viewPortH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    var viewPortW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if (viewPortW > 1023) {
      triggerVideoOnView(element);
    }

    $(window).on('scroll', function () {
      if (viewPortW > 1023) {
        triggerVideoOnView(element);
      }
    });
    $(window).on('resize', function () {
      viewPortH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      viewPortW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if (viewPortW > 1023) {
        triggerVideoOnView(element);
      }
    });

    function triggerVideoOnView(element) {
      var scrollPos = window.pageYOffset;
      var elementPos = element.offset();
      var elementPosCorrection = elementPos.top - (viewPortH / 2);
      var elementEnd = elementPos.top + element.height() / 1.4;

      function playVideo(element) {
        media.play();
      };

      function stopVideo(element) {
        media.pause();
        media.currentTime = 0;
      };

      if (scrollPos > elementPosCorrection && scrollPos < elementEnd) {
        // hide image
        playVideo(element);
      } else {
        stopVideo(element);
      }
    };

    function pictureOnClick() {
      $('.call-center-bar').fadeOut();
      if (viewPortW > 1023 && media.currentTime == media.duration) {
        media.play();
      } else if (viewPortW < 1024) {
        element.addClass('full_screen_mode');
        media.pause();
        media.currentTime = 0;
        media.play();
      }
    };

    // Since the picture it's on top of the video, the video click will not be
    // accesible unless the full screen mode it's activaded
    function videoOnClick() {
      if (viewPortW < 1024 && media.currentTime == media.duration) {
        media.play();
      }
    };

    function closeOnClick() {
      $('.call-center-bar').fadeIn();
      element.removeClass('full_screen_mode');
      media.pause();
      media.currentTime = 0;
    };
  }

  $('.grid_dropdown_list li').click(function () {
    if ($(this).find("div").eq(0).hasClass('active')) {
      $(this).find("div").eq(0).toggleClass('active');
      $(this).find('.collapse').toggleClass('active');
      $(this).find('.icon-chevron-down').toggleClass('active');
    } else {
      $('.grid_dropdown_list li .active').removeClass('active');
      $(this).find("div").eq(0).toggleClass('active');
      $(this).find('.collapse').toggleClass('active');
      $(this).find('.icon-chevron-down').toggleClass('active');
    }
  });

  $('.tabs-nav-item').click(function () {
    var link = $(this).data("tabs-link");
    var content = $(".tabs-wrapper .tabs-content-pane[data-tabs-content-pane='" + link + "']");
    if ($(this).hasClass('is-active')) {
      // $(this).toggleClass('is-active');
      // content.toggleClass('is-active');
    } else {
      $('.is-active').removeClass('is-active');
      $(this).toggleClass('is-active');
      content.toggleClass('is-active');
    }
  });

  $('.tab-component__tab').click(function () {
    var link = $(this).data("tabs-link");
    var content = $(".tab-component__tab-content[data-tabs-content-pane='" + link + "']");
    if ($(this).hasClass('is-active')) {
    } else {
      $('.is-active').removeClass('is-active');
      $(this).toggleClass('is-active');
      content.toggleClass('is-active');
    }
  });

  $('.new-ring-home .ring-protect__accordion-visible').click(function () {
    var imgId = '#' + $(this).data("img-link");
    $('.new-ring-home .ring-protect__accordion-img').removeClass('show');
    $(imgId).addClass('show');
  });

});

function expandFaq(e) {
  $(e).toggleClass('on');
  $(e).next().slideToggle();
}